import { createSlice } from '@reduxjs/toolkit';
import { PoiAdminState } from '../../../types/poiAdmin';

const initialState: PoiAdminState = {
  poiCodePreference: undefined,
  poiCreateMinimumRole: undefined,
  selectedCustomPoiIds: [],
  customPois: [],
  customPoisTotal: 0,
  customPoisPageNumber: 1,
  locationTypes: [],
  poisLoading: false,
  poisLoadingFailed: false,
  locationTypesLoading: false,
  locationTypesLoadingFailed: false,
  poisDeleteSuccess: false,
  poisDeleteFailed: false,
  poiPreferenceUpdating: false,
  poiPreferenceUpdateSuccess: false,
  poiPreferenceUpdateFailed: false,
  selectedCustomPoi: undefined,
  editingCustomPoi: undefined,
  poiUpdating: false,
  poiUpdateSuccess: false,
  poiUpdateFailed: false
};

const poiAdminSlice = createSlice({
  name: 'poiAdmin',
  initialState,
  reducers: {
    setPoiCodePreference: (state, action) => {
      state.poiCodePreference = action.payload;
    },
    setPoiCreateMinimumRole: (state, action) => {
      state.poiCreateMinimumRole = action.payload;
    },
    setSelectedCustomPoiIds: (state, action) => {
      state.selectedCustomPoiIds = action.payload;
    },
    setCustomPois: (state, action) => {
      state.customPois = action.payload;
    },
    setCustomPoisTotal: (state, action) => {
      state.customPoisTotal = action.payload;
    },
    setCustomPoisPageNumber: (state, action) => {
      state.customPoisPageNumber = action.payload;
    },
    setLocationTypes: (state, action) => {
      state.locationTypes = action.payload;
    },
    setPoisLoading: (state, action) => {
      state.poisLoading = action.payload;
    },
    setPoisLoadingFailed: (state, action) => {
      state.poisLoadingFailed = action.payload;
    },
    setLocationTypesLoading: (state, action) => {
      state.locationTypesLoading = action.payload;
    },
    setLocationTypesLoadingFailed: (state, action) => {
      state.locationTypesLoadingFailed = action.payload;
    },
    setPoisDeleteSuccess: (state, action) => {
      state.poisDeleteSuccess = action.payload;
    },
    setPoisDeleteFailed: (state, action) => {
      state.poisDeleteFailed = action.payload;
    },
    setPoiPreferenceUpdating: (state, action) => {
      state.poiPreferenceUpdating = action.payload;
    },
    setPoiPreferenceUpdateSuccess: (state, action) => {
      state.poiPreferenceUpdateSuccess = action.payload;
    },
    setPoiPreferenceUpdateFailed: (state, action) => {
      state.poiPreferenceUpdateFailed = action.payload;
    },
    setSelectedCustomPoi: (state, action) => {
      state.selectedCustomPoi = action.payload;
    },
    setEditingCustomPoi: (state, action) => {
      state.editingCustomPoi = action.payload;
    },
    setPoiUpdating: (state, action) => {
      state.poiUpdating = action.payload;
    },
    setPoiUpdateSuccess: (state, action) => {
      state.poiUpdateSuccess = action.payload;
    },
    setPoiUpdateFailed: (state, action) => {
      state.poiUpdateFailed = action.payload;
    },
    reset: state => {
      Object.assign(state, initialState);
    }
  }
});

export const {
  setPoiCodePreference,
  setPoiCreateMinimumRole,
  setSelectedCustomPoiIds,
  setCustomPois,
  setCustomPoisTotal,
  setCustomPoisPageNumber,
  setLocationTypes,
  setPoisLoading,
  setPoisLoadingFailed,
  setLocationTypesLoading,
  setLocationTypesLoadingFailed,
  setPoisDeleteSuccess,
  setPoisDeleteFailed,
  setPoiPreferenceUpdating,
  setPoiPreferenceUpdateSuccess,
  setPoiPreferenceUpdateFailed,
  setSelectedCustomPoi,
  setEditingCustomPoi,
  setPoiUpdating,
  setPoiUpdateSuccess,
  setPoiUpdateFailed,
  reset
} = poiAdminSlice.actions;

export default poiAdminSlice;
